/**
 * @generated SignedSource<<07b9499f74a0c31c181e0685d15fe8e0>>
 * @relayHash 52013f0873cfb55c65dc863935d18fe5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cbde4e508d29770e80a55d02198aad11082b6e45226b9cd72314d0ee9f5f64d7

import type { ConcreteRequest } from 'relay-runtime';
export type PageTreeMacroExcerptQuery$variables = {
  id: string;
};
export type PageTreeMacroExcerptQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
      } | null;
      readonly macroExcerpt: {
        readonly atlasDocFormat: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type PageTreeMacroExcerptQuery = {
  response: PageTreeMacroExcerptQuery$data;
  variables: PageTreeMacroExcerptQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "concreteType": "ConfluenceMacroExcerptBody",
  "kind": "LinkedField",
  "name": "macroExcerpt",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fallbackToBody",
          "value": false
        }
      ],
      "kind": "ScalarField",
      "name": "atlasDocFormat",
      "storageKey": "atlasDocFormat(fallbackToBody:false)"
    }
  ]
},
v3 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "atlas_doc_format",
      "plural": false,
      "selections": [
        {
          "concreteType": "EmbeddedMediaToken",
          "kind": "LinkedField",
          "name": "mediaToken",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "token"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageTreeMacroExcerptQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageTreeMacroExcerptQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "52013f0873cfb55c65dc863935d18fe5",
    "id": "cbde4e508d29770e80a55d02198aad11082b6e45226b9cd72314d0ee9f5f64d7",
    "metadata": {},
    "name": "PageTreeMacroExcerptQuery",
    "operationKind": "query",
    "text": "query PageTreeMacroExcerptQuery($id:ID!){content(id:$id){nodes{macroExcerpt{atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format{mediaToken{token}}},id}}}"
  }
};
})();

(node as any).hash = "e9b6f3a3e542e69f0e195cee46734cf8";

export default node;
